module.exports = __webpack_public_path__ + "img/es.4d209262.png";